import type { ReactNode } from "react";
import styled from "styled-components";

import { Badge } from "@com.mgmtp.a12.widgets/widgets-core/lib/badge";
import { Button, ButtonProps } from "@com.mgmtp.a12.widgets/widgets-core/lib/button";

const StyledButton = styled(Button)<{ toggled: boolean }>`
	${props => (props.toggled ? "border: 2px solid #00589f" : "")}
`;

export function ToggleButton({
	badgeCount,
	badgeTooltip,
	...props
}: ButtonProps & { badgeCount?: number; badgeTooltip?: string; toggled: boolean }): ReactNode {
	let badge = null;
	if (badgeCount) {
		// The badge already exposes its title to screen readers.
		const badgeTitle = badgeTooltip ?? `${badgeCount} Element${badgeCount > 1 ? "e" : ""}`;
		badge = <Badge count={badgeCount} title={badgeTitle} />;
	}

	return <StyledButton {...props} badge={badge} aria-pressed={props.toggled} />;
}
